import type { RouteObject } from 'react-router';
import { StoryPage } from './pages/StoryPage';

/**
 * The viewer is full-screen and covers the layout, but it still lives inside the
 * app shell: leaving it there means the page behind is already rendered when the
 * story closes, so closing is instant rather than a fresh mount.
 */
export const storyRoutes: RouteObject[] = [{ path: 'stories/:slug', element: <StoryPage /> }];
